<template>
    <v-layout row wrap>
        <v-flex
                v-for="highlight in highlights"
                xs12 md6
                :key="highlight.id"
        >
            <!--The card representing the Highlight can be defined with 3 elements:
            1 - image   2 - title   3 - short description
            It is mandatory to have an image or a title; the description is optional. -->
            <!-- @modified ana.castro 2019.12.05 SCLAPP-23: the highlights must include a link-->
            <v-card flat style="background: transparent" fill-height :href="highlight.website" target="_blank">
                <v-img v-if="highlight.image"
                       v-bind:src="baseUrl + highlight.image"
                       fill-height>
                    <v-container fill-height fluid pa-2>
                        <v-layout fill-height>
                            <v-flex v-if="highlight.name" xs12 align-end flexbox>
                                <span class="headline" v-text="highlight.name"></span>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-img>
                <v-card-title v-if="highlight.description" primary-title>
                    <v-card-text v-html="highlight.description">
                    </v-card-text>
                </v-card-title>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {highlightsService} from '../../_services'
import {getErrorMessage} from '../../_helpers'
import {mapGetters} from "vuex";

export default {
    name: "Highlights",
    data: () => {
        return {
            highlights: [],
        }
    },
    computed: {
        ...mapGetters({
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    mounted() {
        this.$store.dispatch("loader/setLoading", true);
        // eslint-disable-next-line
        highlightsService.getAll().then(result => {
                this.highlights = result.results;
                this.$store.dispatch("loader/setLoading", false);
            },
            error => {
                getErrorMessage(error, 'Getting the Highlights', this);
            });
    }
}
</script>

<style scoped>

</style>